import { render, staticRenderFns } from "./AddedToCartModal.vue?vue&type=template&id=07445dd4&"
import script from "./AddedToCartModal.vue?vue&type=script&lang=js&"
export * from "./AddedToCartModal.vue?vue&type=script&lang=js&"
import style0 from "./AddedToCartModal.vue?vue&type=style&index=0&id=07445dd4&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports